import { useEffect } from "react";
import AuthenticatedRoutes from "./routes/AuthenticatedRoutes";
import UnAuthenticatedRoutes from "./routes/UnAuthenticatedRoutes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useGlobalState } from "./GlobalProvider";
import { GoogleOAuthProvider } from "@react-oauth/google";

function App() {
  const { globalState } = useGlobalState();

  const renderLayout = () => {
    if (globalState?.user) {
      return <AuthenticatedRoutes />;
    } else {
      return <UnAuthenticatedRoutes />;
    }
  };
  return (
    <>
      <GoogleOAuthProvider clientId="659237982094-qb4rum6nr690r8899aqk8bm7ni17un79.apps.googleusercontent.com">
        {renderLayout()}
        <ToastContainer />
      </GoogleOAuthProvider>
    </>
  );
}

export default App;
